import { FEATURE_CODES, hasAllFeatures } from './features.js';

export const LKW_INVOICE_ALLOWED_ROLES = Object.freeze([
  'admin',
  'economist',
  'dispatcher',
]);

export const LKW_INVOICE_REQUIRED_FEATURES = Object.freeze([
  FEATURE_CODES.PROFITABILITY,
  FEATURE_CODES.LKW_INVOICE_EXTRACTION,
]);

export const canAccessLkwInvoices = ({ role, features } = {}) => (
  LKW_INVOICE_ALLOWED_ROLES.includes(String(role || '').trim().toLowerCase())
  && hasAllFeatures(features, ...LKW_INVOICE_REQUIRED_FEATURES)
);
